import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-em-manutencao',
  templateUrl: './em-manutencao.component.html',
  styleUrls: ['./em-manutencao.component.scss']
})
export class EmManutencaoComponent {


  public get whatsUrl(): string {
    const textoWhatsapp = `Olá! Gostaria de tirar uma dúvida sobre os meus boletos.`;
    const numeroWhatsapp = '5511971233055';
    return `https://api.whatsapp.com/send?phone=${numeroWhatsapp}&text=${textoWhatsapp}`;
  }
} 